module.exports = __webpack_public_path__ + "static/media/UY.485b8a32.svg";